<template>
  <v-dialog
      v-model="modelValue"
      :width="1000"
      persistent
  >
    <v-card>
      <div class="">
        <div class="d-flex align-center primary pl-3 pr-2">
          <div class="flex-grow-1 sub--text">
            Import Employees
          </div>
          <div>
            <v-btn
                icon
                color="white"
                small
                @click="modelValue = false"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-divider></v-divider>
        <div class="" style="overflow-x: hidden; overflow-y: hidden">
          <v-tabs v-model="page">
            <v-tab>
              Data
            </v-tab>
            <v-tab :disabled="!importDataRaw || !importFarm">
              Review
            </v-tab>
            <v-tab :disabled="!importDataRaw || !importFarm || !importData || !importData.length">
              Process
            </v-tab>
            <!--Data-->
            <v-tab-item>
              <v-card flat>
                <v-card-text class="py-0">
                  <v-autocomplete
                      color="primary"
                      dense
                      hide-details
                      item-text="description"
                      item-value="id"
                      :items="farms"
                      label="Select Farm"
                      class="pt-4"
                      v-model="importFarm"
                  />
                  <v-textarea
                      class="pt-3"
                      label="Please Paste Data From The Excel Template Here"
                      hide-details
                      color="primary"
                      v-model="importDataRaw"
                      rows="5"
                  />
                </v-card-text>
                <v-card-actions>
                  
                  <v-spacer/>
                  <v-btn
                      :disabled="!importDataRaw || !importFarm"
                      small
                      color="primary"
                      @click="page = ++page"
                  >Next
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            
            <!--Review-->
            <v-tab-item>
              <v-card flat>
                <v-card-text class="pa-0" style="overflow-x: auto">
                  <v-data-table
                      :headers="importHeaders"
                      :items="importData"
                      :items-per-page="5"
                      class="elevation-1"
                      style="min-width: 1000px"
                  ></v-data-table>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                      :disabled="!importData || !importData.length"
                      small
                      color="primary"
                      @click="page = ++page"
                  >Next
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text class="py-0">
                  <div class="d-flex font-weight-medium">
                    <div class="flex-equal flex-grow-1">Processed:</div>
                    <div class="flex-equal flex-grow-1">{{ importResult.processed }}</div>
                  </div>
                  <div class="d-flex green--text font-weight-medium">
                    <div class="flex-equal flex-grow-1">Inserted:</div>
                    <div class="flex-equal flex-grow-1">{{ importResult.inserted }}</div>
                  </div>
                  <div class="d-flex green--text font-weight-medium">
                    <div class="flex-equal flex-grow-1">Updated:</div>
                    <div class="flex-equal flex-grow-1">{{ importResult.updated }}</div>
                  </div>
                  <div class="d-flex red--text font-weight-medium">
                    <div class="flex-equal flex-grow-1">Errors:</div>
                    <div class="flex-equal flex-grow-1">{{ importResult.errors }}</div>
                  </div>
                  <div class="d-flex orange--text font-weight-medium">
                    <div class="flex-equal flex-grow-1">Skipped:</div>
                    <div class="flex-equal flex-grow-1">{{ importResult.skipped }}</div>
                  </div>
                  <v-progress-linear class="my-2" color="secondary" :value="importResult.progress"/>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                      v-if="!importResult.ran"
                      small
                      color="primary"
                      @click="startImport()"
                  >Start Import
                  </v-btn>
                  <v-btn
                      v-else
                      :disabled="importing"
                      :loading="importing"
                      small
                      color="primary"
                      @click="modelValue = false"
                  >Done
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </div>
        <!--                <div class="text-right pr-2 pt-2 pb-2">-->
        <!--                    <v-btn-->
        <!--                            @click="validateSave()"-->
        <!--                            fab-->
        <!--                            small-->
        <!--                            color="secondary"-->
        <!--                            :loading="loading"-->
        <!--                            :disabled="!changesMade || loading"-->
        <!--                    >-->
        <!--                        <v-icon v-if="!loading">mdi-content-save</v-icon>-->
        <!--                    </v-btn>-->
        <!--                </div>-->
      </div>
    </v-card>

    <v-dialog v-model="conflictDialog" :width="700" persistent>
      <v-card>
        <div class="d-flex align-center primary pl-3 pr-2">
          <div class="flex-grow-1 sub--text">Duplicate Employee Code Found</div>
        </div>
        <v-divider/>
        <v-card-text v-if="conflictData" class="pt-4">
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Field</th>
                <th>Existing (in DB)</th>
                <th>Incoming (from file)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="field in conflictFields" :key="field.key">
                <td class="font-weight-medium">{{ field.label }}</td>
                <td :class="{'red--text': conflictData.existing[field.key] !== conflictData.incoming[field.key]}">
                  {{ conflictData.existing[field.key] || '-' }}
                </td>
                <td :class="{'green--text': conflictData.existing[field.key] !== conflictData.incoming[field.key]}">
                  {{ conflictData.incoming[field.key] || '-' }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-btn small color="error" @click="resolveConflict('cancel')">Cancel Import</v-btn>
          <v-spacer/>
          <v-btn small color="orange" dark @click="resolveConflict('skip')">Skip</v-btn>
          <v-btn small color="primary" @click="resolveConflict('update')">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-dialog>
</template>

<script>

function download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

import {mapGetters} from "vuex";

export default {
  components: {},
  props: {
    value: Boolean,
  },
  data() {
    return {
      page: 0,
      importFarm: null,
      importDataRaw: null,
      importHeaders: [
        {value: 'fullName', text: 'Full Name', sortable: true},
        {value: 'idNo', text: 'ID No', sortable: true},
        {value: 'empCode', text: 'Emp Code', sortable: true},
        {value: 'fkFarm', text: 'Import Farm', sortable: true},
        {value: 'team', text: 'Team', sortable: true},
        {value: 'jobDesc', text: 'Job Description', sortable: true},
        // {value: 'dob', text: 'Birth Day', sortable: true},
        // {value: 'startingDate', text: 'Starting Date', sortable: true},
        // {value: 'gender', text: 'Gender', sortable: true},
        // {value: 'citizenship', text: 'Citizenship', sortable: true},
        {value: 'exportID', text: 'Export ID', sortable: true},
        {value: 'shiftName', text: 'Shift', sortable: true},
        {value: 'barcodes', text: 'Barcodes', sortable: true},
      ],
      importResult: {
        ran: false,
        index: 0,
        progress: 0,
        processed: 0,
        errors: 0,
        updated: 0,
        inserted: 0,
        skipped: 0
      },
      importing: false,
      conflictDialog: false,
      conflictData: null,
      conflictResolve: null,
      conflictFields: [
        {key: 'fullName', label: 'Full Name'},
        {key: 'idNo', label: 'ID No'},
        {key: 'empCode', label: 'Emp Code'},
        {key: 'fkFarm', label: 'Farm'},
        {key: 'team', label: 'Team'},
        {key: 'jobDesc', label: 'Job Description'},
        {key: 'exportID', label: 'Export ID'},
      ]
    }
  },
  watch: {
    page: {
      immediate: true,
      handler(val) {
        if (val === 2)
          this.importResult = {
            ran: false,
            index: 0,
            progress: 0,
            processed: `0 of ${this.importData.length}`,
            errors: 0,
            updated: 0,
            inserted: 0,
            skipped: 0
          }
      }
    }
  },
  methods: {
    
    resolveConflict(action) {
      this.conflictDialog = false
      if (this.conflictResolve) this.conflictResolve(action)
    },

    showConflict(existing, incoming) {
      this.conflictData = {existing, incoming}
      this.conflictDialog = true
      return new Promise((resolve) => {
        this.conflictResolve = resolve
      })
    },

    async startImport() {
      this.importResult.ran = true
      const vm = this
      const errors = [];

      const importItem = (item, force = false) => {
        const url = force ? `setup/import/emp?force=true` : `setup/import/emp`
        return vm.$newReq('POST', url, item)
      }

      this.importing = true;
      const shiftMap = new Map(this.$store.state.shifts.map(v => [v.name, v.id]))
      let cancelled = false;

      for (const row of this.importData) {
        if (cancelled) break;

        if (row.shiftName)
          row.fkShift = shiftMap.get(row.shiftName)

        try {
          const res = await importItem(row)
          if (res === 'updated')
            vm.importResult.updated = ++vm.importResult.updated
          else
            vm.importResult.inserted = ++vm.importResult.inserted
        } catch (e) {
          if (e.response && e.response.status === 409) {
            const action = await this.showConflict(e.response.data.existing, row)
            if (action === 'update') {
              try {
                const res = await importItem(row, true)
                if (res === 'updated')
                  vm.importResult.updated = ++vm.importResult.updated
                else
                  vm.importResult.inserted = ++vm.importResult.inserted
              } catch (e2) {
                vm.importResult.errors = ++vm.importResult.errors
              }
            } else if (action === 'cancel') {
              cancelled = true
            } else {
              vm.importResult.skipped = ++vm.importResult.skipped
            }
          } else if (e.response && e.response.status === 406) {
            errors.push({...row, actualFarm: e.response.data.fkFarm})
            vm.importResult.errors = ++vm.importResult.errors
          } else {
            vm.importResult.errors = ++vm.importResult.errors
          }
        }

        vm.importResult.index = ++vm.importResult.index
        vm.importResult.progress = Math.floor(((vm.importResult.index + 1) / vm.importData.length) * 100)
        vm.importResult.processed = `${vm.importResult.index} of ${vm.importData.length}`
      }

      if (errors.length) {
        const xls = require('json-as-xlsx');
        let data = [{
          sheet: "Import Errors",
          columns: [
            {label: "Full Name", value: "fullName"},
            {label: "ID", value: "idNo"},
            {label: "Emp Code", value: "empCode"},
            {label: "Reason", value: "reason"},
          ],
          content: errors.map((errLine) => {
            return {...errLine, reason: this.farmsRef[errLine.actualFarm].description}
          })
        }]
        let settings = {
          fileName: "Import Errors.xlsx",
        }
        xls(data, settings)
      }
      this.importing = false;
    }
  },
  computed: {
    ...mapGetters(['farms', 'farmsRef']),
    
    importData() {
      try {
        let rows = this.importDataRaw.split(/\n/g)
        const headers = rows.shift().split(/\t/g)
        rows = rows.reduce((rows, line) => {
          if (!line)
            return rows
          try {
            const items = line.split(/\t/g);
            const obj = items.reduce((obj, value, index) => {
              obj[headers[index]] = value || null;
              return obj
            }, {})
            rows.push(obj);
            return rows;
          } catch (e) {
            return rows
          }
        }, []);
        
        
        let rowValues = rows.reduce((list, obj) => {
          try {
            const emp = {
              fullName: `${obj['NAME'] || ''}${obj['First names'] || ''} ${obj['SURNAME'] || ''}${obj['Surname'] || ''}`.trim(),
              idNo: `${obj['ID NO'] || ''}${obj['PASSPORT NO'] || ''}${obj['ID number'] || ''}${obj['Passport number'] || ''}`.trim(),
              empCode: obj['CO NO'] || obj['CO'],
              fkFarm: this.importFarm,
              team: obj['TEAM'] || obj['Coin group'],
              jobDesc: obj['JOB DESCRIPTION'],
              shiftName: obj['Shift'] || obj['Shift'] || obj['shift'],
              dob: obj['BIRTH DATE'],
              startingDate: obj['START DATE'],
              gender: obj['M/F (GENDER)'],
              citizenship: obj['CITIZENSHIP'],
              exportID: obj['EXPORT ID'] || obj['Coin number 1'],
              barcodes: []
            }
            
            if (obj['UNIQUE CODE 1'])
              emp.barcodes.push(obj['UNIQUE CODE 1'])
            
            if (obj['UNIQUE CODE 2'])
              emp.barcodes.push(obj['UNIQUE CODE 2'])
            
            if (obj['BARCODE NO 1'])
              emp.barcodes.push(obj['BARCODE NO 1'])
            
            if (obj['BARCODE NO 2'])
              emp.barcodes.push(obj['BARCODE NO 2'])
            
            list.push(emp)
            return list
          } catch (e) {
            return list
          }
        }, [])
        return rowValues
      } catch (e) {
        return 'null'
      }
    },
    
    
    modelValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
}
</script>

<style scoped>

</style>